<template>
  <form>
    <div class="row">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-12">
            <h4 class="card-title font-weight-bold">{{$t('medium_grant_ev.esms__summary_title')}}</h4>
          </div>
        </div>
        <application-info></application-info>
        <div class="mt-3">
          <p class="font-weight-bold mb-3">{{$t('medium_grant_ev.upload_here_esms_summary_report')}}</p>
          <upload-file v-model="EvaluationForm.files.esms.esms_summary_report" :select-text="$t('medium_grant_ev.esms_summary_report__upload')" :is-evaluation="true" :size-limit="EvaluationForm.fileSizeLimit" :file-data="EvaluationForm.files.esms.esms_summary_report" :is-editable="EvaluationForm.isEditable" section="esms.esms_summary_report"></upload-file>
        </div>
      </div>
      <div class="col-lg-3">
        <info-right></info-right>
      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import ApplicationInfo from '../ApplicationInfo';

  export default {
    components: {
      InfoRight,
      ApplicationInfo
    },
    data() {
      return {
        EvaluationForm
      }
    },
    beforeCreate() {
      if (!EvaluationForm.files.esms) {
        EvaluationForm.files.esms = {};
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>
